import { createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys } from "vue";
const _hoisted_1 = ["disabled"];
const _hoisted_2 = ["href"];
const _hoisted_3 = ["disabled"];
const _hoisted_4 = ["href"];
const _hoisted_5 = ["disabled"];
const _hoisted_6 = {
  key: 1,
  class: "portal-legal-renewal-error",
  role: "alert"
};
const _hoisted_7 = ["disabled"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("dialog", {
    ref: "dialog",
    class: "portal-legal-renewal",
    "aria-modal": "true",
    "aria-labelledby": "portal-legal-renewal-title",
    "aria-describedby": "portal-legal-renewal-description",
    onCancel: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["prevent"])),
    onKeydown: _cache[5] || (_cache[5] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["esc"]))
  }, [_cache[13] || (_cache[13] = _createElementVNode("h2", {
    id: "portal-legal-renewal-title"
  }, "Frissültek dokumentumaink!", -1)), _ctx.status?.login_acceptance_required ? (_openBlock(), _createElementBlock("form", {
    key: 0,
    onSubmit: _cache[2] || (_cache[2] = _withModifiers((...args) => $options.save && $options.save(...args), ["prevent"]))
  }, [_cache[12] || (_cache[12] = _createElementVNode("p", {
    id: "portal-legal-renewal-description"
  }, "Elérhetővé vált az XMED frissített Általános Szerződési Feltételei és Adatkezelési tájékoztatója. Kérjük, olvassa el őket, és a folytatáshoz jelölje be a kötelező mezőket.", -1)), _createElementVNode("label", null, [_withDirectives(_createElementVNode("input", {
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.choices.terms = $event),
    type: "checkbox",
    required: "",
    disabled: _ctx.saving || _ctx.loading
  }, null, 8, _hoisted_1), [[_vModelCheckbox, _ctx.choices.terms]]), _createElementVNode("span", null, [_cache[7] || (_cache[7] = _createTextVNode("Elolvastam és elfogadom az ", -1)), _createElementVNode("a", {
    href: $options.terms.url,
    target: "_blank",
    rel: "noopener noreferrer"
  }, [...(_cache[6] || (_cache[6] = [_createElementVNode("strong", null, "Általános Szerződési Feltételeket", -1)]))], 8, _hoisted_2), _cache[8] || (_cache[8] = _createTextVNode(". *", -1))])]), _createElementVNode("label", null, [_withDirectives(_createElementVNode("input", {
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _ctx.choices.gdpr = $event),
    type: "checkbox",
    required: "",
    disabled: _ctx.saving || _ctx.loading
  }, null, 8, _hoisted_3), [[_vModelCheckbox, _ctx.choices.gdpr]]), _createElementVNode("span", null, [_cache[10] || (_cache[10] = _createTextVNode("Elolvastam és tudomásul vettem az ", -1)), _createElementVNode("a", {
    href: $options.privacy.url,
    target: "_blank",
    rel: "noopener noreferrer"
  }, [...(_cache[9] || (_cache[9] = [_createElementVNode("strong", null, "Adatkezelési tájékoztatóban", -1)]))], 8, _hoisted_4), _cache[11] || (_cache[11] = _createTextVNode(" foglaltakat. *", -1))])]), _createElementVNode("button", {
    class: "portal-legal-renewal-save",
    type: "submit",
    disabled: !$options.canSave || _ctx.saving || _ctx.loading
  }, _toDisplayString(_ctx.saving ? 'Mentés…' : 'Mentés'), 9, _hoisted_5)], 32)) : _createCommentVNode("", true), _ctx.error ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("p", null, _toDisplayString(_ctx.error), 1), _createElementVNode("button", {
    type: "button",
    disabled: _ctx.loading || _ctx.saving,
    onClick: _cache[3] || (_cache[3] = (...args) => $options.refresh && $options.refresh(...args))
  }, "Dokumentumok újratöltése", 8, _hoisted_7)])) : _createCommentVNode("", true)], 544);
}